(function(){
  if(!document.getElementById('story')){document.documentElement.style.setProperty('--p','1');return;}
  const NS='http://www.w3.org/2000/svg';
  const el=(tag,attrs,parent)=>{const n=document.createElementNS(NS,tag);for(const k in attrs)n.setAttribute(k,attrs[k]);parent&&parent.appendChild(n);return n;};
  let seed=7;const rnd=()=>{seed=(seed*16807)%2147483647;return (seed-1)/2147483646;};
  const city=document.getElementById('city');
  [[76,236,30,168,'#3a4762'],[114,196,38,208,'#2c3850'],[172,250,28,154,'#34425e'],[210,214,40,190,'#28334a']].forEach(([x,y,w,h,c])=>{
    el('rect',{x,y,width:w,height:h,fill:c},city);
    el('rect',{x,y,width:w,height:2,fill:'#6d7a94'},city);
    for(let yy=y+10;yy<y+h-6;yy+=14)for(let xx=x+5;xx<x+w-6;xx+=10)if(rnd()>.55)el('rect',{x:xx,y:yy,width:5,height:7,fill:rnd()>.3?'#ffc06a':'#ffe2a8'},city);
  });
  const bulbs=document.getElementById('bulbs');
  for(let i=0;i<=8;i++){const t=i/8;const x=(1-t)*(1-t)*66+2*(1-t)*t*161+t*t*256;const y=(1-t)*(1-t)*122+2*(1-t)*t*168+t*t*122;
    el('circle',{cx:x,cy:y+6,r:10,fill:'url(#glowSmall)'},bulbs);el('circle',{cx:x,cy:y+6,r:3.2,fill:'#ffd780'},bulbs);}
  const spots=document.getElementById('spots');
  [70,160,250,340].forEach(x=>{el('rect',{x:x-5,y:46,width:10,height:12,rx:2,fill:'#1f1a16'},spots);el('path',{d:`M${x-5} 58 L${x-34} 220 L${x+34} 220 L${x+5} 58Z`,fill:'url(#beam)'},spots);});
  const books=document.getElementById('books');
  const palette=['#b5522b','#e9c98a','#2f5b34','#f08a2e','#7b7a3a','#c4520c','#d9c3a0','#5a2a1c','#3d5a6c','#efe0c4'];
  [162,232,302,372].forEach((shelfY,row)=>{
    let x=304;
    while(x<396){
      if(rnd()<.14&&x<380){
        const c=palette[Math.floor(rnd()*palette.length)];
        el('path',{d:`M${x+2} ${shelfY} q-4 -14 2 -24 h8 q6 10 2 24z`,fill:c},books);x+=16;continue;
      }
      const w=4+Math.floor(rnd()*6),h=30+Math.floor(rnd()*26);
      el('rect',{x,y:shelfY-h,width:w,height:h,fill:palette[Math.floor(rnd()*palette.length)]},books);
      x+=w+1;
    }
  });
  const planks=document.getElementById('planks');
  for(let i=-6;i<14;i++){const x=i*40;el('line',{x1:200+(x-200)*.45,y1:528,x2:x*1.35-70,y2:880},planks);}
  const rug=document.getElementById('rug');
  const rugTop=600,rugBot=740,l0=34,r0=366,l1=-20,r1=420;
  const at=(t)=>{const y=rugTop+(rugBot-rugTop)*t;return{y,l:l0+(l1-l0)*t,r:r0+(r1-r0)*t};};
  const band=(t0,t1,fill,op)=>{const a=at(t0),b=at(t1);el('polygon',{points:`${a.l},${a.y} ${a.r},${a.y} ${b.r},${b.y} ${b.l},${b.y}`,fill,style:op},rug);};
  band(0,1,'','fill:var(--c-rug1)');
  const op='opacity:clamp(0,calc((var(--p) - .25)*4),1)';
  band(.08,.92,'#e9c98a',op);band(.16,.84,'#2c3d4a',op);band(.24,.76,'#e9c98a',op);band(.32,.68,'#b5522b',op);
  [.12,.88].forEach(t=>{const a=at(t);for(let x=a.l+10;x<a.r-10;x+=16)el('path',{d:`M${x} ${a.y} l8 -5 l8 5 l-8 5z`,fill:'#b5522b',style:op},rug);});
  {const a=at(.5);for(let x=a.l+30;x<a.r-30;x+=34)el('path',{d:`M${x} ${a.y} l14 -9 l14 9 l-14 9z`,fill:'#e9c98a',style:op},rug);}
  [0,1].forEach(t=>{const a=at(t);for(let x=a.l;x<a.r;x+=6)el('line',{x1:x,y1:a.y,x2:x+(t?1:-1),y2:a.y+(t?8:-6),stroke:'#e6dccb','stroke-width':1.2,style:op},rug);});
  (function soften(){
    const ink=document.getElementById('ink'); if(!ink) return;
    let sd=11; const r1=()=>{sd=(sd*16807)%2147483647;return (sd-1)/2147483646*2-1;};
    const keep=['style','fill','class','transform','opacity','fill-opacity','stroke','stroke-width','stroke-opacity','id'];
    const swap=(el,d)=>{const pth=document.createElementNS(NS,'path');keep.forEach(a=>{if(el.hasAttribute(a))pth.setAttribute(a,el.getAttribute(a));});pth.setAttribute('d',d);el.replaceWith(pth);};
    const bow=(ax,ay,bx,by,k)=>{const dx=bx-ax,dy=by-ay,L=Math.hypot(dx,dy)||1;const b=r1()*Math.min(k,L*.025);return `Q${(ax+bx)/2-dy/L*b} ${(ay+by)/2+dx/L*b} ${bx} ${by}`;};
    ink.querySelectorAll('rect').forEach(el=>{
      if(el.closest('#city')&&+el.getAttribute('width')<8) return;
      const x=+el.getAttribute('x')||0,y=+el.getAttribute('y')||0,w=+el.getAttribute('width'),h=+el.getAttribute('height');
      if(!w||!h) return;
      const rx=el.hasAttribute('rx')?+el.getAttribute('rx'):Math.min(5,w/3,h/3);
      const r=Math.min(rx,w/2,h/2), k=Math.min(2.4,Math.min(w,h)*.08);
      const d=`M${x+r} ${y} ${bow(x+r,y,x+w-r,y,k)} Q${x+w} ${y} ${x+w} ${y+r} ${bow(x+w,y+r,x+w,y+h-r,k)} Q${x+w} ${y+h} ${x+w-r} ${y+h} ${bow(x+w-r,y+h,x+r,y+h,k)} Q${x} ${y+h} ${x} ${y+h-r} ${bow(x,y+h-r,x,y+r,k)} Q${x} ${y} ${x+r} ${y}Z`;
      swap(el,d);
    });
    ink.querySelectorAll('polygon').forEach(el=>{
      const pts=el.getAttribute('points').trim().split(/[\s,]+/).map(Number);const P=[];for(let i=0;i<pts.length;i+=2)P.push([pts[i],pts[i+1]]);
      let d=`M${P[0][0]} ${P[0][1]}`;for(let i=0;i<P.length;i++){const a=P[i],b=P[(i+1)%P.length];d+=' '+bow(a[0],a[1],b[0],b[1],2.4);}
      swap(el,d+'Z');
    });
  })();
  const pairs={
    wall:['#e4e0d8','#2c3d4a'], wall2:['#dcd7cd','#a8442a'], sky:['#d0d2cf','#04060b'], frame:['#f2efe9','#1a1410'],
    beam:['#e9e5dd','#5b544d'], beamEdge:['#d6d1c7','#3f3934'], column:['#ebe7e0','#8a8178'],
    curtain:['#f1eee8','#c99a2e'], curtainFold:['#dcd8d0','#a07a1e'], shelf:['#ddd8ce','#5e3519'],
    floor:['#d6d0c4','#6b3f24'], plank:['#c8c1b3','#4f2d18'], rug1:['#e2dccf','#5a2a1c'],
    lantern:['#f2efe9','#f08a2e'], rib:['#d6d1c7','#c4520c'],
    sofa:['#ece8e0','#5a2a1c'], sofaShade:['#d9d4ca','#3e1c12'],
    table:['#d2ccc0','#3a2418'], tableTop:['#e3ded4','#5a3622'], dome:['#f0ece5','#f2e6d2'], plant:['#b7bab2','#2f5b34'], plant2:['#c4c6bf','#3f7346']
  };
  const root=document.documentElement, stage=document.getElementById('stage');
  const hex=h=>[1,3,5].map(i=>parseInt(h.slice(i,i+2),16));
  const pre={};for(const k in pairs)pre[k]=[hex(pairs[k][0]),hex(pairs[k][1])];
  const mix=(A,B,t)=>'rgb('+A.map((v,i)=>Math.round(v+(B[i]-v)*t)).join(',')+')';
  const story=document.getElementById('story');
  const layers=[...stage.querySelectorAll('.layer')];
  const caps=[1,2,3].map(i=>document.getElementById('cap'+i));
  const pct=document.getElementById('pct'), state=document.getElementById('state');
  const rows=[...document.querySelectorAll('.row')];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let ticking=false;
  const ease=t=>t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
  function render(){
    ticking=false;
    const r=story.getBoundingClientRect();
    const raw=Math.min(1,Math.max(0,-r.top/Math.max(1,r.height-innerHeight)));
    const p=ease(Math.min(1,raw/0.85));
    root.style.setProperty('--p',p.toFixed(3));
    for(const k in pre)stage.style.setProperty('--c-'+k,mix(pre[k][0],pre[k][1],p));
    pct.textContent=Math.round(p*100)+' %';
    state.textContent=p<.5?'saturé du blanc':'saturé de couleur';
    if(!reduce){
      layers.forEach(l=>{const d=+l.dataset.depth;const s=1+raw*0.09*d;l.setAttribute('transform',`translate(${200-200*s},${-raw*60*d+400-400*s}) scale(${s})`);});
      rows.forEach(row=>{const b=row.getBoundingClientRect();const t=(innerHeight-b.top)/(innerHeight+b.height);row.style.transform=`translateX(${(t-0.5)*30*+row.dataset.dir}%)`;});
    }
    caps[0].classList.toggle('on',raw<0.26);
    caps[1].classList.toggle('on',raw>=0.26&&raw<0.66);
    caps[2].classList.toggle('on',raw>=0.66);
  }
  const req=()=>{if(!ticking){ticking=true;requestAnimationFrame(render);}};
  addEventListener('scroll',req,{passive:true});
  addEventListener('resize',req);
  render();
})();
